/**
* @author 贝才[beica1@outook.com]
* @date 2021/2/9
* @description
*   Tab.vue of WeTrade
*/
<template>
<div class="tab df-middle">
  <RouterLink custom v-for="tab in tabs" :key="tab.path[0]" #="{navigate}" :to="tab.path[0]">
    <div @click="navigate" class="flex-1 f-md f-bold df-cross-center">
      <TransitionPic :path="`tabs/${tab.icon}`" :active="isMatch(tab.path)" />
      <t :class="isMatch(tab.path) ? ['c-primary'] : []" :path="tab.label">
        {{tab.labelDefault}}
      </t>
    </div>
  </RouterLink>
</div>
</template>

<script lang="ts">
import TransitionPic from '@/views/appTab/TransitionPic.vue'
import { defineComponent } from 'vue'
import { useRoute } from 'vue-router'

const tabs = [
  {
    label: 'tab_2',
    path: ['/', '/home'],
    icon: 'home',
    labelDefault: 'Home',
  }, {
    label: 'tab_5',
    path: ['/prime', '/prime/detail'],
    icon: 'prime',
    labelDefault: 'Prime',
  }, {
    label: 'tab_6',
    path: ['/me'],
    icon: 'me',
    labelDefault: 'Me',
  },
]

export default defineComponent({
  name: 'AppTab',
  components: { TransitionPic },
  setup () {
    const route = useRoute()

    const isMatch = (path: string) => path.indexOf(route.path) !== -1

    return {
      tabs,
      isMatch,
    }
  },
})
</script>

<style scoped lang="scss">
.tab {
  color: var(--color-tip);
  background: var(--color-white);
  //box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
}
</style>
